<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="stockMovements.data"
      style="width: 100%"
      row-key="id"
      highlight-current-row
      :row-class-name="'pointer-row'"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="70"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="stockMovement"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :stock-movement="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="stockMovements.per_page"
        layout="total, prev, pager, next"
        :total="stockMovements.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'asc',
        },
      };
    },
    computed: {
      stockMovements() {
        return this.$store.getters['stockMovement/paginatedStockMovements'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['stockMovement/tableConfig']));
      },
      loading() {
        return this.$store.getters['stockMovement/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('stockMovement/setFilterString', '');
      this.$store.commit('stockMovement/setCurrentPage', this.currentPage);
      this.$store.commit('stockMovement/setSorting', this.currentSort);
      await this.$store.dispatch('stockMovement/fetchAllWithPagination');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('stockMovement/setCurrentPage', val);
        this.$store.dispatch('stockMovement/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('stockMovement/setSorting', { prop, order });
          this.$store.dispatch('stockMovement/fetchAll');
        }
      },
    },
  };
</script>


